<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="md:col-8 sm:col-12 comp-grid">
              <div class="card">
                <div class="text-xl text-primary font-bold">
                  Institution Setup Info
                </div>
              </div>
              <Breadcrumb
                :home="{
                  icon: 'pi pi-arrow-left text-lg mr-3',
                  label: 'Back',
                  command: () => {
                    $router.go(-1);
                  },
                }"
                :model="[
                  {
                    label: 'My Account',
                    to: '/account',
                  },
                ]"
              />
            </div>
          </div>
        </div>
      </section>
    </template>
    <Dialog
      header="Offer Letter Template"
      v-if="!loading"
      v-model:visible="offerLetterDialog"
      :style="{ width: '50vw' }"
    >
      <div class="scrollbar" id="style-1" v-html="formData.offer_letter"></div>
    </Dialog>

    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-8 sm:col-12 comp-grid">
            <div class="card">
              <div class="font-bold text-primary mb-3">
                Key Words for Decision Letter
              </div>
              <div class="text-sm">
                These words will be replaced with actual data
              </div>
              <hr />
              <Button
                label="Name of Institution"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{nameOfInstitution}')"
              />
              <Button
                label="Address of Institution"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{addressOfInstitution}')"
              />
              <Button
                label="Name of Applicant"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{nameOfApplicant}')"
              />
              <Button
                label="Address of Applicant}"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{addressOfApplicant}')"
              />
              <Button
                label="Application Number"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{applicationRef}')"
              />
              <Button
                label="Date of Submission"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{dateOfSubmission}')"
              />
              <Button
                label="Institution Website"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{institutionWebsite}')"
              />
              <Button
                label="Institution Telephone"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{institutionTelephone}')"
              />
              <Button
                label="Signature of Registrar"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{signature}')"
              />
              <Button
                label="Name of Registrar"
                type="button"
                class="p-button-sm p-button-primary px-4 py-2 mr-2 mb-2 p-button-rounded p-button-outlined"
                @click="addKeyWord('{name}')"
              />
            </div>
            <div class="card nice-shadow-18">
              <div>
                <template v-if="!loading">
                  <div class="grid">
                    <div class="col-12">
                      <form
                        ref="observer"
                        tag="form"
                        @submit.prevent="startRecordUpdate()"
                      >
                        <!--[form-content-start]-->
                        <div class="grid">
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12">
                                <div class="mb-2 flex justify-content-between">
                                  <div class="font-bold text-sm">
                                    Decision Letter *
                                  </div>
                                  <div class="text-right">
                                    <Button
                                      label="View Letter Template"
                                      type="button"
                                      class="p-button-sm p-button-primary p-button-outlined px-3 py-1"
                                      @click="openOfferLetter()"
                                    />
                                  </div>
                                </div>
                                <div
                                  class="mb-3"
                                  :class="getErrorClass('offer_letter')"
                                >
                                  <Editor
                                    label="Offer Letter"
                                    ref="ctrloffer_letter"
                                    placeholder="Offer Letter"
                                    v-model="formData.offer_letter"
                                    editorStyle="height: 250px"
                                  ></Editor>
                                  <!-- <small class="p-3 text-negative" v-if="invalid && validated">{{errors[0]}}</small> -->
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="formgrid grid">
                              <div class="col-12">
                                <div class="mb-2 font-bold text-sm">
                                  Letter Signature *
                                </div>
                                <div class="mb-3">
                                  <Uploader
                                    :class="getErrorClass('letter_signature')"
                                    :auto="true"
                                    :fileLimit="1"
                                    :maxFileSize="3000000"
                                    accept=".jpg,.png,.gif,.jpeg"
                                    :multiple="false"
                                    style="width: 100%"
                                    label="Choose file or drop file here"
                                    upload-path="s3uploader/upload/letter_signature"
                                    v-model="formData.letter_signature"
                                  ></Uploader>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="md:col-12 col-12">
                            <div class="mb-2 font-bold text-sm">
                              Available Cohort (If applicable)
                            </div>
                            <div id="ctrl-cohort-holder">
                              <MultiSelect
                                class="w-full"
                                :class="getErrorClass('cohort')"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlcohorts"
                                v-model="formData.cohort"
                                :options="$menus.cohort_Items"
                                label="Available Cohort"
                              >
                              </MultiSelect>
                            </div>
                          </div>

                          <div class="col-12">
                            <div class="font-bold text-sm">
                              Bank Account Details *
                            </div>
                            <div class="mb-2 text-xs text-primary">
                              Kindly update/provided details below: Bank Name,
                              Account Number, Account Name, Bank Branch and
                              Swift Code
                            </div>
                            <div id="ctrl-bank_details-holder">
                              <Textarea
                                :class="getErrorClass('bank_details')"
                                class="w-full"
                                ref="ctrlbank_details"
                                rows="5"
                                v-model="formData.bank_details"
                                placeholder="Enter Bank Account Details"
                                type="textarea"
                              >
                              </Textarea>
                            </div>
                          </div>
                        </div>
                        <!--[form-content-end]-->
                        <div v-if="showSubmitButton" class="text-center my-3">
                          <Button
                            type="submit"
                            label="Update Information"
                            icon="pi pi-send"
                            :loading="saving"
                          />
                        </div>
                      </form>
                      <slot :submit="submit" :saving="saving"></slot>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="p-3 text-center">
                    <ProgressSpinner style="width: 50px; height: 50px" />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="sm:col-12 md:col-4">
            <div class="sticky-item"><file-svg-page></file-svg-page></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import fileSvgPage from "../custom/file_svg.vue";
import { PageMixin } from "../../mixins/page.js";
import { EditPageMixin } from "../../mixins/editpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "editCapsinstitutionslistPage",
  components: { fileSvgPage },
  mixins: [PageMixin, EditPageMixin],
  props: {
    pageName: {
      type: String,
      default: "caps_institutions_list",
    },
    idName: {
      type: String,
      default: "caps_institution_id",
    },
    routeName: {
      type: String,
      default: "caps_institutions_listedit",
    },
    pagePath: {
      type: String,
      default: "caps_institutions_list/edit",
    },
    apiPath: {
      type: String,
      default: "caps_institutions_list/edit",
    },
  },
  data() {
    return {
      formData: {
        offer_letter: "",
        letter_signature: "",
        bank_details: "",
        cohort: "",
      },
      offerLetterDialog: false,
      submitted: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Edit Caps Institutions List";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters["caps_institutions_list/currentRecord"];
      },
      set: function (value) {
        this.$store.commit("caps_institutions_list/setCurrentRecord", value);
      },
    },
  },
  validations() {
    let formData = {
      offer_letter: { required },
      letter_signature: { required },
      bank_details: { required },
      cohort: {},
    };
    return { formData };
  },
  methods: {
    ...mapActions("caps_institutions_list", ["updateRecord", "fetchRecord"]),
    openOfferLetter() {
      this.offerLetterDialog = true;
    },
    async startRecordUpdate() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Please complete the form", "Form is invalid", "error");
        return;
      }
      this.saving = true;
      let id = this.id;
      let url = this.apiUrl;
      let payload = this.normalizedFormData();
      let data = { id, url, payload };
      this.updateRecord(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(this.msgAfterUpdate);
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          location.reload();
          // if (this.redirect) this.navigateTo(`/caps_institutions_list`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    addKeyWord(text) {
      const elem = this.$refs.ctrloffer_letter;
      const quill = elem.quill;
      const pos = quill.getSelection(true);
      quill.insertText(pos, text);
    },
    updateFormFields: function () {
      //update form fields value after load from api
      //e.g convert fieldvalue (value,value2,value2) to array
      this.formData.cohort = this.$utils.toArray(this.formData.cohort);
      if (
        this.formData.bank_details == "" ||
        this.formData.bank_details == null
      ) {
        this.formData.bank_details =
          "Bank Name: XXXXXXXXXXXX \r\nAccount Name: XXXXXXX XXXXXXX \r\nAccount Number: 0000000000 \r\nBank Branch: XXXXXXX \r\nSwift Code: XXXXX";
      }
    },
    resetForm() {
      //reset form fields value
      // this.formData = {
      //   offer_letter: "",
      //   letter_signature: "",
      // };
      //raise event to reset other custom form components
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      if (this.v$.formData[field].$invalid && this.submitted) {
        return "p-invalid";
      }
      return "";
    },
  },
  watch: {},
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
